import { useCallback } from "react";

import { useV2DraftCheckoutMutation, useV2GetCheckoutQuery } from "@stepapp/core";
import { V2DraftCheckoutInput } from "@stepapp/core/apiTypes";
import { captureSentryException } from "@stepapp/sentry";

let checkoutPayloadStringRef = JSON.stringify({});
export const useCheckout = ({
  skipValidation = true,
}: { skipValidation?: boolean; isSummaryScreen?: boolean } = {}) => {
  const [v2draftCheckout, { data: draftData, loading: updateLoading }] =
    useV2DraftCheckoutMutation();

  const {
    refetch,
    data: checkoutData,
    loading: checkoutLoading,
  } = useV2GetCheckoutQuery({ skip: skipValidation, fetchPolicy: "cache-and-network" });

  // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  const mutateCheckout = useCallback(
    async (checkoutPayload: V2DraftCheckoutInput, isSummaryScreen: boolean) => {
      try {
        const payloadStringified = JSON.stringify(checkoutPayload || {});

        if (
          Object.keys(checkoutPayload || {}).length === 0 ||
          // Find sth faster to compare
          checkoutPayloadStringRef === payloadStringified
        ) {
          return;
        }
        checkoutPayloadStringRef = payloadStringified;

        if (checkoutPayload.bundleId) {
          await v2draftCheckout({ variables: { data: checkoutPayload } });
          !!isSummaryScreen && refetch();
        }
      } catch (error) {
        captureSentryException("[Mutate checkout error]", {
          extra: {
            //@ts-expect-error
            errorMessage: error?.message,
          },
        });
      }
    },
    [v2draftCheckout, skipValidation],
  );

  return {
    mutateCheckout,
    refetch,
    loading: checkoutLoading || updateLoading,
    checkout: skipValidation ? draftData?.v2DraftCheckout : checkoutData?.v2GetCheckout,
  };
};
